const hasValue = (value) => value != null && String(value).trim() !== '';
const hasSelectedID = (value) => hasValue(value) && String(value) !== '0';
const hasWaNumber = (value) => hasValue(String(value ?? '').trim().replace(/^WA\s*-?\s*/i, ''));

export const isSaleOpportunityValid = (record, options = {}) => {
    if (!record) return false;

    return hasValue(record.name)
        && hasWaNumber(record.waNumber)
        && hasValue(record.date)
        && hasSelectedID(record.typeID)
        && hasSelectedID(record.statusID)
        && hasSelectedID(record.stageID)
        && (!options.requireCompany || hasValue(record.sec))
        && (!options.requireContact || hasValue(record.contactLinkedID));
};
